import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { UserAssignment } from '../types/types';

const initialState:
    {
        Users: UserAssignment[],
    } = {
    Users: [],
}

const Users = createSlice({
    name: 'users',
    initialState,
    reducers: {
        addUsers: (state, action: PayloadAction<UserAssignment[]>) => {
            // todo: check notSync items
            state.Users = action.payload
        }
    }
});

export const { addUsers } = Users.actions;

export default Users.reducer;
